/* global $, jQuery, LocomotiveScroll, google, gsap, Power4, rangePlugin, flatpickr: false */

$(document).ready(function () {
	'use strict';

	let mobileOnlineCheckIn = document.querySelector('.navbar-mobile .mobile-online-checkin');
	let mobileBookNow = document.querySelector('.navbar-mobile .mobile-book-now');

	if (mobileBookNow && mobileOnlineCheckIn) {
		mobileBookNow.style.height = mobileOnlineCheckIn.offsetHeight + "px";
	}

	window.addEventListener('resize', () => {
		if (mobileBookNow && mobileOnlineCheckIn) {
			mobileBookNow.style.height = mobileOnlineCheckIn.offsetHeight + "px";
		}
	});

	const locomotiveScroll = new LocomotiveScroll({
		el: document.querySelector('[data-scroll-container]'),
		smooth: true,
		offset: [0, 0]
	});

	setTimeout(function() {
		window.dispatchEvent(new Event('resize'));
	}, 5000);

	setInterval(function() {
		locomotiveScroll.update();
	}, 5000);

	locomotiveScroll.on('call', (value, way, obj) => {
		switch (value) {
			case 'slider_action' :
				gsap.to(obj.el.querySelectorAll('.destination-slider .photo-wrapper'), {duration: 0.4, "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", stagger: 0.1});
				break;
			case 'items_slider_action' :
				gsap.to(obj.el.querySelectorAll('.posts-slider .posts-slide-image'), {duration: 0.4, "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", stagger: 0.1});
				break;
			case 'items_room_full_action' :
				gsap.to(obj.el.querySelectorAll('.posts-slider .image-wrapper'), {duration: 0.4, "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", stagger: 0.1});
				break;
			case 'fade_in_action' :
				gsap.to(obj.el.querySelectorAll('.fade-in-me'), {
					duration: 2,
					y: 0,
					opacity: function(index, target, targets) {
						if (target.classList.contains('first-slideshow-slogan-subtitle')) {
							return 0.4;
						}
						return 1;
					},
					ease: 'power4.out',
					stagger: 0.1
				});
				break;

			default:
				//console.log(`Sorry, we are out of ${value}.`);
		}
	});

	window.locomotiveScroll = locomotiveScroll;

	/**
	 * Masonry Gallery
	 */
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {
		function setPaddingTop() {
			Array.from(document.querySelectorAll('.masonry-gallery a.photo-link')).forEach((link) => {
				const imageWidth = link.dataset.width;
				const imageHeight = link.dataset.height;
				const ratio = (imageHeight / imageWidth) * 100;
				link.style.paddingTop = `${ratio}%`;
			});
		}

		function toggleLazy(imageElement) {
			// console.log('toggleLazy called');
			const src = imageElement.dataset.lazy;
			if (src && src.length) {
				imageElement.src = src;
				// $gallery.isotope.layout();
				imageElement.removeAttribute('data-lazy');
				window.dispatchEvent(new Event('resize'));
			}
		}

		/**
		 * init Isotope after all images have loaded
		 */
		$gallery.imagesLoaded().always(function( instance ) {
			// console.log('always');
		});

		$gallery.imagesLoaded().progress(function () {
			$gallery.isotope('layout');
			window.dispatchEvent(new Event('resize'));
		});

		// setPaddingTop();

		$gallery.isotope({
			initLayout: false,
			itemSelector: '.gallery-item',
			percentPosition: true,
			masonry: {
				gutter: '.gallery-gutter-sizer',
				columnWidth: '.gallery-item-sizer'
			}
		});

		setTimeout(function() {
			$gallery.isotope('layout');
			locomotiveScroll.update();
		}, 100);

		$gallery.on('arrangeComplete', function(filteredItems) {
			$gallery.isotope('layout');
			locomotiveScroll.update();
		});


		/**
		 * Filter items on button click
		 */
		$('.masonry-gallery-filters').on('click', 'li a', function () {
			$gallery.isotope({
				filter: $(this).attr('data-filter')
			});
		});

		locomotiveScroll.on('call', (value, way, obj) => {
			switch (value) {
				case 'masonry-item':
					if (way === 'enter') {
						const { el } = obj;
						toggleLazy(el.querySelector('img'));
					}
					break;

				default:
					//console.log(`Sorry, we are out of ${value}.`);
			}
		});
	}

	/**
	 * Google Map
	 */
	let $map = $('.map');
	if ($map.length > 0) {
		$map.each((index, element) => {
			let elMap = $(element);
			elMap.googleMap(elMap.data('json'));
		});
	}

	function openMenu(ev) {
		ev.preventDefault();

		$('.group-menu-wrapper').addClass('is-open');

		// let tl = new gsap.timeline({ paused: true });

		gsap.to('.all-menus-wrapper', { duration: 1, y: '70px', ease: Power4.easeOut });
		gsap.fromTo('.wrapper-menu-primary .primary-menu li', { y: '-15px', opacity: 0 }, { delay: 0.4, duration: 1, y: 0, opacity: 1, ease: Power4.easeOut, stagger: 0.07 });
		gsap.fromTo('.group-logo-inline', { opacity: 0 }, { delay: 0.3, duration: 0.4, opacity: 1, ease: Power4.easeOut });
		gsap.fromTo('#navbar-language-switcher-secondary', { opacity: 0 }, { delay: 0.2, duration: 0.4, opacity: 1, ease: Power4.easeOut });

		if ($(window).width() < 1200) {
			gsap.fromTo('.hotels-list li', { y: '-15px', opacity: 0 }, { delay: 0.6, duration: 1, y: 0, opacity: 1, ease: Power4.easeOut, stagger: 0.07 });
			gsap.fromTo('.hotels-list-wrapper > div', { y: '-15px', opacity: 0 }, { delay: 0.6, duration: 1, y: 0, opacity: 1, ease: Power4.easeOut });
			gsap.fromTo('.bottom-links-wrapper a', { opacity: 0 }, { delay: 0.8, duration: 0.5, opacity: 1, ease: Power4.easeOut });
			gsap.fromTo('.helper .check-in', { opacity: 0 }, { delay: 0.8, duration: 0.5, opacity: 1, ease: Power4.easeOut });
			gsap.fromTo('.live-icon', { opacity: 0 }, { delay: 0.8, duration: 0.5, opacity: 1, ease: Power4.easeOut });
		}
	}

	function closeMenu(ev) {
		ev.preventDefault();

		$('.group-menu-wrapper').removeClass('is-open');

		gsap.to('.all-menus-wrapper', { duration: 0.5, y: '-105%', ease: Power4.easeOut });
	}


	Array.from(document.querySelectorAll('.burger-button, .icon-close-wrapper')).map(el => {
		el.addEventListener('click', (ev) => {
			if (!document.querySelector('.group-menu-wrapper').classList.contains('is-open')) {
				openMenu(ev);
			} else {
				closeMenu(ev);
			}
		}, false);
	});

	function openBoxMenu(ev) {
		ev.preventDefault();

		gsap.fromTo('.box-menu-wrapper', { opacity: 0, y: '-103%' }, { opacity: 1, y: 0, duration: 1, ease: Power4.easeOut });
		gsap.fromTo('.box-menu-wrapper .close-btn', { opacity: 0 }, { duration: 0.5, opacity: 1, delay: 1 });

		gsap.fromTo('.box-menu-content .hotels-list-wrapper .text-primary', { opacity: 0, y: '-10px' }, { delay: 0.4, duration: 0.3, opacity: 1, y: '0' });
		gsap.fromTo('.box-menu-content .hotels-list-wrapper svg', { opacity: 0 }, { delay: 0.4, duration: 0.3, opacity: 1 });
		gsap.fromTo('.box-menu-content .hotels-list-wrapper .hotels-list li', { opacity: 0, y: '-10px' }, { delay: 0.4, duration: 0.3, opacity: 1, y: '0', stagger: 0.07 });

		gsap.fromTo('.box-menu-content .social-wrapper .social li', { opacity: 0, y: '-10px' }, { delay: 1, duration: 0.3, opacity: 1, y: '0', stagger: 0.07 });
		gsap.fromTo('.box-menu-content .social-wrapper > div', { opacity: 0 }, { delay: 1.3, duration: 0.3, opacity: 1 });

		gsap.fromTo('.box-menu-content .main-menu-wrapper .primary-menu li', { opacity: 0, y: '-10px' }, { delay: 0.4, duration: 0.3, opacity: 1, y: '0', stagger: 0.07 });

		gsap.fromTo('.box-menu-content .apps-wrapper .footer-links > div', { opacity: 0, y: '-10px' }, { delay: 1, duration: 0.3, opacity: 1, y: '0', stagger: 0.07 });
	}

	function closeBoxMenu(ev) {
		ev.preventDefault();
		document.body.classList.remove('box-menu-opened');
		gsap.to('.box-menu-wrapper', { duration: 0.8, y: '-103%', ease: Power4.easeOut, opacity: 0 });
	}

	$('.group-logo-vertical .group-logo, .menu-button').on('click', function (ev) {
		openBoxMenu(ev);
		document.body.classList.add('box-menu-opened');
	});

	$('.box-menu-wrapper .close-btn').on('click', function (ev) {
		closeBoxMenu(ev);
	});

	document.addEventListener('keyup', function(ev) {
		if (ev.key === 'Escape' && document.body.classList.contains('box-menu-opened')) {
			closeBoxMenu(ev);
		}
	});

	class ChangePositions {

		constructor() {
			this.onResizeBind = this.onResize.bind(this);
			this.elements = $('[data-change-position]');
			this.breakpoint = 768;
			this.onResize();
			window.addEventListener('resize', this.onResizeBind);
		}

		onResize() {
			Array.from(this.elements).forEach(div => {
				let target = document.querySelector(div.dataset.target);
				if (!target) return;

				if (window.innerWidth >= (div.dataset.breakpoint || this.breakpoint)) {
					if (!target.children.length) {
						this.moveChildren(div, target);
					}
				} else if (!div.children.length) {
					this.moveChildren(target, div);
				}
			});
		}

		moveChildren(element, target) {
			Array.from(element.children).forEach(element => target.appendChild(element));
		}


		destroy() {
			window.removeEventListener('onresize', this.onResizeBind);
		}

	}

	let changePosition = document.querySelector('[data-change-position]');
	if (changePosition) {
		changePosition = new ChangePositions();
	}

	function clearDropDown( element ) {
		const $this = $(element);

		$this.find('[data-all').addClass('current').siblings().removeClass('current');

		const $t = $( '#' + $this.closest('.dropdown-menu').attr('aria-labelledby') );

		const $new_div = $('<div/>', {
			'class': 'd-flex align-items-center p-0'
		}).html( $this.find('[data-all').eq(0).html() );
		$t.html( $new_div );
	}

	$('.dropdown-menu[aria-labelledby="dropdownDestination"] .dropdown-item').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			const parent = element.closest('.dropdown-menu');
			const target = parent.dataset.target;
			const $target = $('#' + target);

			$this.addClass('current').siblings().removeClass('current');
			const locality = element.dataset.destination;

			let $t = $( '#' + parent.getAttribute('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$t.html( $new_div );

			clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownExperience"]') );

			if ('all' !== locality) {
				$target.find('[data-locality]').hide();
				$target.find('[data-locality=' + locality + ']').show();
			} else {
				$target.find('[data-locality]').show();
			}

			if ('undefined' !== typeof parent.dataset.scrollToTarget) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 20
				}, 500);
			}

			if ('undefined' !== typeof parent.dataset.isFlickity) {
				$target.flickity('reloadCells');
				$target.flickity('select', 0);
				// $target.flickity('reposition')
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});

	$('.dropdown-menu[aria-labelledby="dropdownExperience"] .dropdown-item').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			const parent = element.closest('.dropdown-menu');
			const target = parent.dataset.target;
			const $target = $('#' + target);

			$this.addClass('current').siblings().removeClass('current');
			const experience_id = element.dataset.experience;

			let $t = $( '#' + parent.getAttribute('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$t.html( $new_div );

			clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownDestination"]') );

			if ('all' !== experience_id) {
				$target.find('[data-experience]').hide();
				$target.find('[data-experience]').each((i, el) => {
					let $el = $(el);
					if ($el.data('experience').includes(experience_id)) {
						$el.show();
					}
				});
			} else {
				$target.find('[data-experience]').show();
			}

			if ('undefined' !== typeof parent.dataset.scrollToTarget) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 20
				}, 500);
			}

			if ('undefined' !== typeof parent.dataset.isFlickity) {
				$target.flickity('reloadCells');
				$target.flickity('select', 0);
				// $target.flickity('reposition')
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});

	// $('.dropdown-menu[aria-labelledby="dropdownDestination"] .dropdown-item').each((index, element) => {
	// 	$(element).on('click', ev => {
	// 		ev.preventDefault();
	// 		const $this = $(element);
	// 		const parent = element.closest('.dropdown-menu');
	// 		const target = parent.dataset.target;
	// 		const $target = $('#' + target);
	//
	// 		$this.addClass('current').siblings().removeClass('current');
	// 		const locality = element.dataset.destination;
	//
	// 		let $t = $( '#' + parent.getAttribute('aria-labelledby') );
	// 		const $new_div = $('<div/>', {
	// 			'class': 'd-flex align-items-center p-0'
	// 		}).html( $this.html() );
	// 		$t.html( $new_div );
	//
	// 		clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownExperience"]') );
	//
	// 		if ('all' !== locality) {
	// 			$target.find('[data-locality]').hide();
	// 			$target.find('[data-locality=' + locality + ']').show();
	// 		} else {
	// 			$target.find('[data-locality]').show();
	// 		}
	//
	// 		if ('undefined' !== typeof parent.dataset.scrollToTarget) {
	// 			$([document.documentElement, document.body]).animate({
	// 				scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 20
	// 			}, 500);
	// 		}
	//
	// 		if ('undefined' !== typeof parent.dataset.isFlickity) {
	// 			$target.flickity('reloadCells');
	// 			$target.flickity('select', 0);
	// 			// $target.flickity('reposition')
	// 		}
	//
	// 		setTimeout(() => {
	// 			locomotiveScroll.update();
	// 		}, 250);
	// 	});
	// });
	//
	// $('.dropdown-menu[aria-labelledby="dropdownExperience"] .dropdown-item').each((index, element) => {
	// 	$(element).on('click', ev => {
	// 		ev.preventDefault();
	// 		const $this = $(element);
	// 		const parent = element.closest('.dropdown-menu');
	// 		const target = parent.dataset.target;
	// 		const $target = $('#' + target);
	//
	// 		$this.addClass('current').siblings().removeClass('current');
	// 		const experience_id = element.dataset.experience;
	//
	// 		let $t = $( '#' + parent.getAttribute('aria-labelledby') );
	// 		const $new_div = $('<div/>', {
	// 			'class': 'd-flex align-items-center p-0'
	// 		}).html( $this.html() );
	// 		$t.html( $new_div );
	//
	// 		clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownDestination"]') );
	//
	// 		if ('all' !== experience_id) {
	// 			$target.find('[data-experience]').hide();
	// 			$target.find('[data-experience]').each((i, el) => {
	// 				let $el = $(el);
	// 				if ($el.data('experience').includes(experience_id)) {
	// 					$el.show();
	// 				}
	// 			});
	// 		} else {
	// 			$target.find('[data-experience]').show();
	// 		}
	//
	// 		if ('undefined' !== typeof parent.dataset.scrollToTarget) {
	// 			$([document.documentElement, document.body]).animate({
	// 				scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 20
	// 			}, 500);
	// 		}
	//
	// 		if ('undefined' !== typeof parent.dataset.isFlickity) {
	// 			$target.flickity('reloadCells');
	// 			$target.flickity('select', 0);
	// 			// $target.flickity('reposition')
	// 		}
	//
	// 		setTimeout(() => {
	// 			locomotiveScroll.update();
	// 		}, 250);
	// 	});
	// });
	//

	$('.dropdown-menu[aria-labelledby="dropdownHotels"] .dropdown-item').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			const parent = element.closest('.dropdown-menu');
			const $target = $('#' + parent.dataset.target);

			$this.addClass('current').siblings().removeClass('current');
			const hotel = element.dataset.selectedHotel;

			let $t = $( '#' + parent.getAttribute('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$t.html( $new_div );

			clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownJobCategories"]') );

			if ( 'all' !== hotel ) {
				$target.find('[data-hotel]').hide();
				$target.find('[data-hotel=' + hotel + ']').show();
			} else {
				$target.find('[data-hotel]').show();
			}

			if ('undefined' !== typeof parent.dataset.scrollToTarget) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 100
				}, 500);
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});

	$('.dropdown-menu[aria-labelledby="dropdownJobCategories"] .dropdown-item').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			const parent = element.closest('.dropdown-menu');
			const $target = $('#' + parent.dataset.target);

			$this.addClass('current').siblings().removeClass('current');
			const jobCategory = element.dataset.selectedJobCategory;

			let $t = $( '#' + parent.getAttribute('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$t.html( $new_div );

			clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownHotels"]') );

			if ( 'all' !== jobCategory ) {
				$target.find('[data-job-category]').hide();
				$target.find('[data-job-category=' + jobCategory + ']').show();
			} else {
				$target.find('[data-job-category]').show();
			}

			if ('undefined' !== typeof parent.dataset.scrollToTarget) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $target.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight - 100
				}, 500);
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});

	$('.dropdown-menu[aria-labelledby="dropdownPartnerCategory"] .dropdown-item').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			const parent = element.closest('.dropdown-menu');
			const target = parent.dataset.target;
			const $target = $('#' + target);

			$this.addClass('current').siblings().removeClass('current');
			const category = element.dataset.category;

			let $t = $( '#' + parent.getAttribute('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$t.html( $new_div );

			$('#partner-tags-list .tag-item a[data-tag="all"]').trigger('click');

			if ('all' !== category) {
				$target.find('[data-category]').hide();
				$target.find('[data-category=' + category + ']').show();
			} else {
				$target.find('[data-category]').show();
			}

			if ('undefined' !== typeof parent.dataset.scrollToTarget) {
				locomotiveScroll.scrollTo(document.getElementById('the-partners-list'), {offset: -1 * document.querySelector('.group-menu-wrapper').offsetHeight});
			}

			if ('undefined' !== typeof parent.dataset.isFlickity) {
				$target.flickity('reloadCells');
				$target.flickity('select', 0);
				// $target.flickity('reposition')
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});

	$('#partner-tags-list .tag-item a').each((index, element) => {
		$(element).on('click', ev => {
			ev.preventDefault();
			const $this = $(element);
			if ( $this.hasClass('is-active')) {
				return true;
			}
			const parent = element.closest('#partner-tags-list');
			const target = parent.dataset.target;
			const $target = $('#' + target);

			$this.addClass('is-active').closest('.tag-item').siblings().find('a').removeClass('is-active');
			const tag = element.dataset.tag;

			clearDropDown( $('.dropdown-menu[aria-labelledby="dropdownPartnerCategory"]') );

			if ('all' !== tag) {
				$target.find('[data-tags]').hide().each((ind, el) => {
					if ($(el).data('tags').toString().indexOf(tag) !== -1) {
						$(el).show();
					}
				});
			} else {
				$target.find('[data-tags]').show();
			}

			setTimeout(() => {
				locomotiveScroll.update();
			}, 250);
		});
	});


	let $notSure = $('.not-sure');

	function notSureListener(ev) {
		if (0 === $notSure.length) return true;

		if ($notSure.hasClass('is-active')) {
			let target = ev.target.closest('.not-sure-content');
			if (null === target) {
				$notSure.find('.close-icon').trigger('click');
			}
		}
	}


	$('.not-sure-button').on('click', ev => {
		ev.preventDefault();
		setTimeout(function () {
			$notSure.addClass('is-active');
		}, 10);
	});

	document.addEventListener('click', notSureListener, false);

	$notSure.find('.close-icon').on('click', ev => {
		ev.preventDefault();
		$notSure.removeClass('is-active');
	});

	/* COMPARE ROOMS */
	const compareRooms = function () {

		const maxNumberOfRooms = 6;
		const buttonsInList = document.querySelectorAll('[data-compare-list]');
		const ckeckboxesInForm = document.querySelectorAll('[data-compare-form]');
		let isAjaxWorking = false;

		const selectedRooms = [];
		const submitButton = document.getElementById('submit-room-compare');

		const currentRoomInput = document.querySelector('[data-current-room-id]');

		/* If we are on a single room page include its id in the array */
		if (currentRoomInput) {
			selectedRooms.push(currentRoomInput.getAttribute('data-current-room-id'));
		}

		/* Run this every time an input gets updated */
		function checkSelected(idsArray, newId) {
			/* Update array of selected roomids */
			if (idsArray.includes(newId)) {
				idsArray.splice(idsArray.indexOf(newId), 1);
			} else if (selectedRooms.length < maxNumberOfRooms) {
				idsArray.push(newId);
			}

			/* Update fake checkboxes in room posts */
			buttonsInList.forEach(function (button) {
				if (idsArray.includes(button.getAttribute('data-compare-list'))) {
					button.classList.add('is-selected');
				} else {
					button.classList.remove('is-selected');
				}
			});

			/* Update real checkboxes in form */
			ckeckboxesInForm.forEach(function (box) {
				if (idsArray.includes(box.getAttribute('data-compare-form'))) {
					box.checked = true;
					box.classList.add('is-selected');
				} else {
					box.checked = false;
					box.classList.remove('is-selected');
				}
			});

			/* Show/Hide submit button */
			if (idsArray.length > 1) {
				submitButton.classList.add('is-active');
			} else {
				submitButton.classList.remove('is-active');
			}
		}

		/* Event listener for fake checkboxes in room posts */
		buttonsInList.forEach(function (button) {
			button.addEventListener('click', function () {
				const buttonId = button.getAttribute('data-compare-list');
				checkSelected(selectedRooms, buttonId);
			});
		});

		/* Event listener for real checkboxes in form */
		ckeckboxesInForm.forEach(function (box) {
			box.addEventListener('click', function () {
				const boxId = box.getAttribute('data-compare-form');
				checkSelected(selectedRooms, boxId);
			});
		});

		submitButton.addEventListener('click', function (e) {
			e.preventDefault();

			const btn = this;

			btn.classList.add('is-loading');

			if (isAjaxWorking) return;

			isAjaxWorking = true;

			const nonce = $('#room-compare-form #_wpnonce').val();
			const ajaxUrl = $('#room-compare-form #wp-ajax-url').val();

			const formData = {
				'nonce': nonce,
				'action': 'room_compare',
				'selected_rooms': selectedRooms.join(),
			};

			if ('el' === $('html')[0].lang) {
				formData.querylang = 'el';
			} else {
				formData.querylang = 'en';
			}

			$.ajax({
				method: 'POST',
				url: ajaxUrl,
				data: formData,
				success: (ajax_response) => {
					ajax_response = $.parseJSON(ajax_response);
					$('#modal-post-content').empty().append(ajax_response.rooms_table);
					$('#room-compare-modal').modal('show');
				},
				complete: () => {
					isAjaxWorking = false;
					btn.classList.remove('is-loading');
				}
			});
		});
	};

	const roomForm = document.getElementById('room-compare-form');
	if (roomForm) {
		compareRooms();
	}

	/* POSTS SLIDER */
	const $customSlider = $('.slider-custom-buttons');
	if ($customSlider) {
		$customSlider.each(function() {
			const $sliderWrapper = $(this);
			const $slider = $sliderWrapper.find('[data-flickity]');
			const $buttonPrev = $sliderWrapper.find('.custom-slider-prev');
			const $buttonNext = $sliderWrapper.find('.custom-slider-next');
			const $currentSlide = $sliderWrapper.find('.custom-slider-counter .current');

			$buttonPrev.on('click', function () {
				$slider.flickity('previous');
			});
			$buttonNext.on('click', function () {
				$slider.flickity('next');
			});
			$slider.flickity().on('change.flickity', function (e, i) {
				const current = i + 1;
				$currentSlide.text(current);
			});
		});
	}

	/* ROOM NUMBER INPUTS */
	document.querySelectorAll('[data-numinput-target]').forEach(function (button) {
		const input = document.getElementById(button.getAttribute('data-numinput-target'));
		const min = parseInt(input.getAttribute('min'));
		const max = parseInt(input.getAttribute('max'));
		const action = button.getAttribute('data-action');
		button.addEventListener('click', function () {
			let value = input.value ? parseInt(input.value) : min;
			if (action === 'incr' && value < max) {
				input.value = value + 1;
			} else if (action === 'decr' && value > min) {
				input.value = value - 1;
			}
		});
	});

	// const $firstSlideShow = $('.hotel-page .slideshow.first-slideshow');
	const $firstSlideShow = $( '.slideshow.first-slideshow' );

	if ($firstSlideShow.length > 0) {
		$firstSlideShow.next('.buttons-wrapper').find('.all-sliders-count').html($firstSlideShow.find('.slideshow-cell').length);

		$('.slider-button').on('click', ev => {
			ev.preventDefault();
			const $btn = $(ev.target);
			const $btnWrapper = $btn.closest('.buttons-wrapper');
			const $slider = $btnWrapper.prev('.slideshow');
			$slider.flickity($btn.attr('aria-label').toLowerCase(), true);
			$btnWrapper.find('.slider-count').html($slider.data('flickity').selectedIndex + 1);
		});

		$firstSlideShow.on('change.flickity', (ev, index) => {
			$firstSlideShow.next('.buttons-wrapper').find('[data-scroll-container]').html(index + 1);
		});
	}

	accordionToggler();

	let imageWrappers = document.querySelectorAll(".variations-images .image-wrapper");

	let imageWrappersParent = document.querySelector(".variations-images");

	let specsParent = document.querySelector(".specs-div");

	let targetListItems, i;

	let dropdownInitialValue = null;

	let prevValue = null;

	const $peopleAmount = $('.js-people-amount');

	// Specifications list item when clicked then change layout image
	$('.js-specification-title').on('click', (ev, forced = false) => {

		ev.preventDefault();

		if (dropdownInitialValue === null) {
			dropdownInitialValue = $(ev.currentTarget);
		}
		let $this = dropdownInitialValue;

		if (!forced) {
			$this = $(ev.currentTarget);
			prevValue = $this;
		}
		else {
			$this = prevValue;
		}

		const $parent = $this.parent(); // .dropdown-menu

		const dataVar = $this.data('var');

		if ( $parent.hasClass('dropdown-menu')) {

			// const $peopleRange = $('#people-range');
			// if ( $peopleRange.length ) {
			// 	$peopleRange.val( $peopleRange.attr('min') );
			// 	$peopleRange.trigger('input');
			// }

			// Copy item content to dropdown in order to show the user's selection
			let $target = $( '#' + $parent.attr('aria-labelledby') );
			const $new_div = $('<div/>', {
				'class': 'd-flex align-items-center p-0'
			}).html( $this.html() );
			$target.html( $new_div );

			// Add active class on selected item
			$this.addClass('current').siblings().removeClass('current');

			const $targetList = $($parent.data('target'));

			if ( 'all' === dataVar ) {
				targetListItems = $targetList.find('[class*="setup-"]');
				for ( i = 0; i < targetListItems.length; i++ ) {
					if ( parseInt( targetListItems[i].getAttribute('data-max-persons'), 10 ) >= $peopleAmount.html() ) {
						targetListItems[i].classList.add('active-for-flickity');
					}
				}
			} else {
				// Filter same setups
				$targetList.find('[class*="setup-"]').removeClass('active-for-flickity');
				targetListItems = $targetList.find('.setup-' + dataVar);
				for ( i = 0; i < targetListItems.length; i++ ) {
					if ( parseInt( targetListItems[i].getAttribute('data-max-persons'), 10 ) >= $peopleAmount.html() ) {
						targetListItems[i].classList.add('active-for-flickity');
					}
				}
			}

			// Reload Cells if Flickity exists
			if ('undefined' !== typeof $parent.get(0).dataset.isFlickity) {
				$targetList.flickity('reloadCells');
				$targetList.flickity('select', 0);

				$targetList.next('.custom-slider-buttons').find('.custom-slider-counter .current').text('1');
				$targetList.next('.custom-slider-buttons').find('.custom-slider-counter .total').text( $targetList.find('.posts-slide-wrapper-large.active-for-flickity').length );
			}


		}

		// Triggering image change
		const $variationsImages = $('.variations-images');
		if ( $variationsImages.length ) {
			$variationsImages.find('.image-wrapper[data-variation="' + dataVar + '"]').show().siblings().hide();
		}

		for ( let i = 0; i < imageWrappers.length; i++ ) {
			if ( imageWrappers[i].classList.contains('has-no-image') && (imageWrappers[i].style.display === 'block') ) {
				imageWrappersParent.classList.add('d-none');
				specsParent.classList.remove('col-lg-6');
				specsParent.classList.add('col-12');
				return;
			}
			else {
				imageWrappersParent.classList.remove('d-none');
				specsParent.classList.remove('col-12');
				specsParent.classList.add('col-lg-6');
			}
		}
	});



	// Range slider for number of people
	let waitingForRangeInput = false;
	$('input[id="people-range"]').on('input', ev => {
		if (waitingForRangeInput) {
			return;
		}
		waitingForRangeInput = true;

		const value = parseInt( ev.target.value, 10 );
		$peopleAmount.html(value);
		const $target = $( ev.target.dataset.target );

		if ( dropdownInitialValue === null ) {
			$target.find('.posts-slide-wrapper-large')
				.removeClass('active-for-flickity')
				.filter(function (index) {
					return parseInt($(this).data('max-persons'), 10) >= value;
				})
				.addClass('active-for-flickity');

			// Reload Cells if Flickity exists
			if ('undefined' !== typeof ev.target.dataset.isFlickity) {
				$target.flickity('reloadCells');
				$target.flickity('select', 0);

				$target.next('.custom-slider-buttons').find('.custom-slider-counter .current').text('1');
				$target.next('.custom-slider-buttons').find('.custom-slider-counter .total').text($target.find('.posts-slide-wrapper-large.active-for-flickity').length);
			}
		}

		else
			$('.js-specification-title').trigger('click', [true]);

		setTimeout(function () {
			waitingForRangeInput = false;
		}, 100);

	});

	const $wh_hotels = $('#wh-hotels');
	if ($wh_hotels.length > 0) {
		$wh_hotels.on('change', function () {
			document.getElementById('webhotelier-form').action = 'https://'+this.value+'.reserve-online.net/';
		});
	}

	function hideFormElements( form = null ) {
		setTimeout( () => {
			$(form).children(':not(.response-row)').slideUp();
		}, 500);
	}

	const $formJobApplicationWrapper = $('#job-application-form-wrapper');
	if ( $formJobApplicationWrapper.length > 0 ) {
		const $jobSelect = $('#job-select');
		$('.js-job-apply').on('click', ev => {
			ev.preventDefault();

			const job = ev.target.dataset.job;

			$jobSelect
				.val([])
				.find('option[value="' + job + '"]')
				.attr('selected', true)
				.change();

			$('html, body').animate({
				scrollTop: $formJobApplicationWrapper.offset().top - document.querySelector('.group-menu-wrapper').offsetHeight
			}, 700);
		});

		$jobSelect.on('change', ev => {
			const $option = $('#job-select option:selected');
			$formJobApplicationWrapper.find('input[name="job-description"]').val($option.text());
		});

		$jobSelect.change();

		const theForm = $formJobApplicationWrapper.find('.wpcf7').get(0);

		theForm.addEventListener('wpcf7submit', ev => {
			$jobSelect.change();
		}, false);

		theForm.addEventListener('wpcf7mailsent', ev => {
			hideFormElements($(theForm).find('form.wpcf7-form'));
		}, false);
	}

	const $formEventRequestWrapper = $('.request-form-wrapper');

	if ( $formEventRequestWrapper.length > 0 ) {

		$('a[href="#request-form-wrapper"]').on('click', ev => {
			ev.preventDefault();

			const button = ev.target;
			const selectedRoom = button.dataset.room || null;
			const formWrapper = document.getElementById('request-form-wrapper');

			if ( selectedRoom ) {
				$(formWrapper).find('#room-select').val(selectedRoom).change();
			}

			locomotiveScroll.scrollTo(
				formWrapper,
				{
					offset: -1 * $('.group-menu-wrapper').height(),
					duration: 1500,
				}
			);
		});

		const theForm = $formEventRequestWrapper.find('.wpcf7').get(0);

		theForm.addEventListener('wpcf7mailsent', () => {
			hideFormElements($(theForm).find('form.wpcf7-form'));
		}, false);
	}

	const openPopup = document.getElementById('open-popup');
	if (openPopup) {
		openPopup.addEventListener('click', ev => {
			ev.preventDefault();
			document.querySelector('.iframe-popup').classList.add('is-active');
		}, false);
	}

	const openPopupSecond = document.getElementById('open-popup-second');
	if (openPopupSecond) {
		openPopupSecond.addEventListener('click', ev => {
			ev.preventDefault();
			document.querySelector('.iframe-popup-second').classList.add('is-active');
		}, false);
	}

	$('button.close').on('click', function(ev) {
		console.log('1111111111');
		ev.preventDefault();
		$('.iframe-popup').removeClass('is-active');
	});

	$('button.close-second').on('click', function(ev) {
		ev.preventDefault();
		$('.iframe-popup-second').removeClass('is-active');
	});

	$('.collapse').on('shown.bs.collapse hidden.bs.collapse', function () {
		locomotiveScroll.update();
	});




	// Custom Collapse
	const customCollapseTriggers = document.querySelectorAll('[data-toggle="custom-collapse"]');

	Array.from(customCollapseTriggers).forEach((trigger) => {
		trigger.addEventListener('click', (ev) => {
			const element = ev.currentTarget;
			const selector = element.getAttribute('data-target');
			element.setAttribute('aria-expanded', 'true' === element.getAttribute('aria-expanded') ? 'false' : 'true');
			document.querySelector(selector).classList.toggle('show');
			setTimeout(function() {
				locomotiveScroll.update();
			}, 500);
		}, false);
	});

	let intervalCounter = 0;
	let intervalID = setInterval(() => {
		if ( intervalCounter >= 5) {
			clearInterval(intervalID);
		} else {
			locomotiveScroll.update();
			intervalCounter++;
		}
	}, 1000);






	// Read more toggle
	const readMoreToggles = document.querySelectorAll('[data-read-more-target]');
	if (readMoreToggles) {
		readMoreToggles.forEach(function(toggle) {
			const target = document.querySelector(toggle.getAttribute('data-read-more-target'));
			const maxHeight = parseInt(toggle.getAttribute('data-max-height'));
			if (target.offsetHeight > maxHeight ) {
				target.classList.add('has-readmore');
				target.classList.add('is-closed');
				target.style.maxHeight = maxHeight.toString() + 'px';
				toggle.classList.remove('d-none');
				toggle.classList.add('d-flex');
				toggle.addEventListener('click', function() {
					if (target.classList.contains('is-closed')) {
						target.classList.remove('is-closed');
						target.classList.add('is-open');
						target.style.maxHeight = 'none';
					} else {
						target.classList.add('is-closed');
						target.classList.remove('is-open');
						target.style.maxHeight = maxHeight.toString() + 'px';
					}
					toggle.classList.toggle('text-is-visible');

					setTimeout(() => {
						locomotiveScroll.update();
					}, 50);
				});
			}
		});
	}
	function hotelsSlider() {
		var $slider = $('#our-hotels-slider');
		var options = {
			prevNextButtons: false,
			pageDots: false,
			draggable: true,
			groupCells: false,
		};
		if ( window.matchMedia('(min-width: 576px)').matches ) {
			options.draggable       = false;
			options.groupCells      = 4;
			options.prevNextButtons = false;
		}
		$slider.flickity(options);
	}

	hotelsSlider();

	function detectHotelZoneHover() {
		function getClassname($element) {
			var num = 0;
			if ( $element.hasClass('hotels__slide--0') ) {
				num = 0;
			} else if ( $element.hasClass('hotels__slide--1') ) {
				num = 1;
			} else if ( $element.hasClass('hotels__slide--2') ) {
				num = 2;
			} else if ( $element.hasClass('hotels__slide--3') ) {
				num = 3;
			}
			return 'is-active--' + num;
		}
		var $hotelZone   = $('.hotels__slider');
		var $hotelSlides = $hotelZone.find('.hotels__slide');
		$hotelSlides.hover(
			function () {
				$hotelZone.removeClass('is-active--0');
				$hotelZone.removeClass('is-active--1');
				$hotelZone.removeClass('is-active--2');
				$hotelZone.removeClass('is-active--3');
				var $className = getClassname($(this));
				$hotelZone.addClass($className);
			}
		)
	}

	detectHotelZoneHover();

	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');

		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					mediaVideo.pause();
					$btnPause.find('.icon').addClass('stop');
				} else {
					mediaVideo.play();
					$btnPause.find('.icon').removeClass('stop');
				}
			});
		}, {});

		observer.observe(mediaVideo);
	}


	const $heroImage = $('.hero-image');
	const $videoPopup = $('.popup-video');

	if ( $heroImage.length > 0 && $videoPopup.length > 0 ) {
		const $playBtn = $('.play-video-icon-wrapper');
		$playBtn.on('click', ev => {
			const $target = $($(ev.target).data('target'));
			const videoElement = $target.find('video').get(0);
			$target.addClass('active');
			videoElement.play();

			$target.find('.closing-x').on('click', ev => {
				videoElement.pause();
				$target.removeClass('active');
			});
		});
	}
});

$(window).on('resize orientationchange', function () {
	accordionToggler();
});

function accordionToggler() {
	'use strict';

	const rewardsCards = document.querySelectorAll('#accordionRewards .card');
	const rewardsCardsButtons = document.querySelectorAll('#accordionRewards .card button');

	if (rewardsCards.length > 0 && rewardsCardsButtons.length > 0 ) {
		rewardsCardsButtons.forEach((btn, index) => {
			const target = btn.dataset.target.substring(1);
			const targetEl = document.getElementById(target);

			if (window.innerWidth < 768) {
				btn.setAttribute('data-toggle', 'collapse');
				btn.setAttribute('aria-expanded', 'false');
				targetEl.classList.remove('show');
				if (index === 0) {
					btn.setAttribute('aria-expanded', 'true');
					targetEl.classList.add('show');
				}
			} else {
				btn.setAttribute('data-toggle', '');
				btn.setAttribute('aria-expanded', 'true');
				targetEl.classList.add('show');
			}
		});
	}
}

(function ($) {
	'use strict';

	/**
	 * Google Map Function
	 */
	$.fn.googleMap = function (options) {
		let el = $(this);

		let settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		let markers = [];
		let bounds = new google.maps.LatLngBounds();

		let offsetHeight = $('nav.navbar').height() * 2;

		offsetHeight = 0 // override to test

		let map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			let locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			let infoButtonString = '';
			let infoImageUrl = '';
			let markerInfowindow = false;
			let icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					anchor: new google.maps.Point(20, 80),
					scaledSize: new google.maps.Size(40, 80),
				};
			}

			if (attr.info_text || attr.info_title) {
				let contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			let marker = new google.maps.Marker({
				position: locLatLng,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});

			markers.push(marker);

			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight && window.innerWidth > 768) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);
		});

		map.setZoom(settings.zoom);

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}
	};

	// Datepicker
	class DatePicker {
		constructor(checkInEl = null, checkOutEl = null) {
			if ( checkInEl && checkOutEl) {
				this.checkInEl = checkInEl;
				this.checkOutEl = checkOutEl;
				flatpickr(this.checkOutEl, {
					dateFormat: 'Y-m-d',
				});
				flatpickr(this.checkInEl, {
					minDate: 'today',
					dateFormat: 'Y-m-d',
					plugins: [new rangePlugin({ input: checkOutEl})],
					disableMobile: 'true'
				});
			}
		}
	}
	let checkin = document.getElementById('event-date-checkin');
	let checkout = document.getElementById('event-date-checkout');

	if (checkin && checkout) {
		new DatePicker(checkin,checkout);
	}

	class DatePickerWebHotelier {
		constructor(checkInEl = null, checkOutEl = null) {
			if ( checkInEl && checkOutEl) {
				this.checkInEl = checkInEl;
				this.checkOutEl = checkOutEl;
				flatpickr(this.checkOutEl, {
					dateFormat: 'd-m-Y',
				});
				flatpickr(this.checkInEl, {
					minDate: 'today',
					dateFormat: 'd-m-Y',
					plugins: [new rangePlugin({ input: checkOutEl})],
					disableMobile: 'true'
				});
			}
		}
	}

	let checkinWebHotelier = document.getElementById('checkin-picker');
	let checkoutWebHotelier = document.getElementById('checkout-picker');

	if (checkinWebHotelier && checkoutWebHotelier) {
		new DatePickerWebHotelier(checkinWebHotelier,checkoutWebHotelier);
	}

	// Timepicker
	class TimePicker {
		constructor(timeFrom = null, timeTo = null) {
			if ( timeFrom && timeTo) {
				this.timeFrom = timeFrom;
				this.timeTo = timeTo;
				flatpickr(this.timeFrom, {
					enableTime: true,
					noCalendar: true,
					dateFormat: "H:i"
				});
				flatpickr(this.timeTo, {
					enableTime: true,
					noCalendar: true,
					dateFormat: "H:i"
				});
			}
		}
	}
	let timeFrom = document.getElementById('time-from');
	let timeTo = document.getElementById('time-to');

	if (timeFrom && timeTo) {
		new TimePicker(timeFrom,timeTo);
	}

	document.addEventListener("DOMContentLoaded", function() {
		let isSafari = window.safari !== undefined;
		if (isSafari) {
			document.body.classList.add("is-safari");
		}
	});
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {

	// Function to show the main popup
	function showPopup() {
		const popupElement = document.getElementById("popup");
		if (popupElement) {
			popupElement.classList.remove('d-none');
		}
	}
	function closePopup() {
		const popupElement = document.getElementById("popup");
		if (popupElement) {
			popupElement.classList.add('d-none');
		}
	}
	function checkPopup() {
		const popupClosed = document.cookie.split('; ').find(row => row.startsWith('popupClosed='));
		if (!popupClosed) {
			setTimeout(showPopup, 300);
		}
	}
	if (document.getElementById("closeButton")) {
		document.getElementById("closeButton").addEventListener("click", closePopup);
	}
	window.addEventListener("load", checkPopup);

	var popupElement = document.getElementById('nelios-popup-49343');
	var popupElementFr = document.getElementById('nelios-popup-49358');
	var popupElementEl = document.getElementById('nelios-popup-49349');
	var popupElementEs = document.getElementById('nelios-popup-49359');
	if (popupElement) {
		var parentElement = popupElement.closest('.nelios-popup-overlay');
		if (parentElement) {
			parentElement.id = popupElement.id;
		}
	}
	if (popupElementFr) {
		var parentElement = popupElementFr.closest('.nelios-popup-overlay');
		if (parentElement) {
			parentElement.id = popupElementFr.id;
		}
	}
	if (popupElementEl) {
		var parentElement = popupElementEl.closest('.nelios-popup-overlay');
		if (parentElement) {
			parentElement.id = popupElementEl.id;
		}
	}
	if (popupElementEs) {
		var parentElement = popupElementEs.closest('.nelios-popup-overlay');
		if (parentElement) {
			parentElement.id = popupElementEs.id;
		}
	}

});

document.addEventListener('DOMContentLoaded', function() {
	const notification = document.getElementById('notification');
	if ( notification ) {
		document.querySelector('#notification .close').addEventListener('click', function() {
			if (notification) {
				notification.remove();
			}

			const wrapperNavbar = document.getElementById('wrapper-navbar');
			const bannerClass = document.querySelector('.notification-banner-open');
			const bannerClassMobile = document.querySelector('.notification-banner-open-mobile');
			const bannerClassBox = document.querySelector('.notification-banner-open-box');
			if (wrapperNavbar) {
				bannerClass.classList.remove('notification-banner-open');
				bannerClassMobile.classList.remove('notification-banner-open-mobile');
				bannerClassBox.classList.remove('notification-banner-open-box');
			}
		});
	}
});

document.addEventListener("DOMContentLoaded", function () {
	const copyBtn = document.querySelector(".copy-code");
	const codeEl = document.querySelector("#voucher-code");

	if (copyBtn && codeEl) {
		copyBtn.addEventListener("click", function () {
			const text = codeEl.innerText.trim();

			navigator.clipboard.writeText(text).then(function () {
				alert("Voucher code copied to clipboard!");
			}).catch(function (err) {
				console.error("Failed to copy: ", err);
			});
		});
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const iframeTriggers = Array.from(document.querySelectorAll('.js-restaurant-iframe-trigger'));
	const iframePopup = document.getElementById('iframePopup');
	const iframeBackdrop = document.getElementById('iframeBackdrop');
	const iframeMount = document.getElementById('iframeMount');
	const iframeClose = document.querySelector('.js-restaurant-iframe-close');

	if (!iframeTriggers.length || !iframePopup || !iframeBackdrop || !iframeMount || !iframeClose) {
		return;
	}

	let iframeElement = null;
	let previousBodyOverflow = '';

	function createIframe(trigger) {
		const iframeSrc = trigger?.dataset?.iframeSrc || '';
		if (!iframeSrc) {
			console.warn('Missing iframe source for restaurant reservation button.');
			return null;
		}

		if (iframeElement) {
			return iframeElement;
		}

		iframeElement = document.createElement('iframe');
		iframeElement.id = 'popupFrame';
		iframeElement.setAttribute('title', 'Restaurant Reservation');
		iframeElement.setAttribute('src', iframeSrc);
		iframeElement.setAttribute('allow', 'camera; microphone; fullscreen; clipboard-read; clipboard-write');
		iframeElement.setAttribute('loading', 'eager');
		iframeElement.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
		iframeMount.appendChild(iframeElement);

		return iframeElement;
	}

	function destroyIframe() {
		if (!iframeElement) {
			return;
		}

		iframeElement.setAttribute('src', 'about:blank');
		iframeElement.remove();
		iframeElement = null;
	}

	function openIframePopup(trigger) {
		const createdIframe = createIframe(trigger);
		if (!createdIframe) {
			return;
		}

		previousBodyOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		iframeBackdrop.style.display = 'block';
		iframePopup.classList.add('active');
	}

	function closeIframePopup() {
		destroyIframe();
		iframePopup.classList.remove('active');
		iframeBackdrop.style.display = 'none';
		document.body.style.overflow = previousBodyOverflow;
	}

	iframeTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			openIframePopup(trigger);
		});
	});

	iframeClose.addEventListener('click', closeIframePopup);
	iframeBackdrop.addEventListener('click', closeIframePopup);

	window.addEventListener('message', function (event) {
		if (event.data && event.data.type === 'closeIframe') {
			closeIframePopup();
		}
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && iframePopup.classList.contains('active')) {
			closeIframePopup();
		}
	});

	window.closeIframePopup = closeIframePopup;
});
